import { useTranslation } from 'react-i18next';

const Chain = () => {
  const { t } = useTranslation();
  return <div>{t('hello')} Chain</div>;
};

export default Chain;
